import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const PickupForm = ({
  pickupItems = [], // currently available items
  pickup,
  onUpdatePickup,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // TODO: IF Pickup transaction exists but the items were already picked up from some other pickup, then remove the transaction?

  return (
    <Box>
      <TextField
        select
        fullWidth
        sx={{ marginTop: "16px" }}
        label="Type"
        value={pickup.pickupType}
        onChange={(e) => {
          let update = {
            pickupType: e.target.value,
          };
          onUpdatePickup(update);
        }}
      >
        <MenuItem value={"PICKUP"}>Pickup</MenuItem>
        <MenuItem value={"DELIVERY"}>Delivery</MenuItem>
      </TextField>
      <TableContainer component={Box} sx={{ margin: 0, padding: 0 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">Item</TableCell>
              {!isSmallScreen && (
                <TableCell align="left" sx={{ width: "120px" }}>
                  Received
                </TableCell>
              )}
              <TableCell align="left" sx={{ width: "70px" }}>
                Available
              </TableCell>
              <TableCell align="left" sx={{ width: "120px" }}>
                Receive
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pickup &&
              pickup.transactions &&
              pickupItems &&
              pickupItems.map((item, index) => {
                // Comment this out to always show ALL. Not just available
                // if (
                //   Number(item.quantity) -
                //     Number(item.quantityReceived) >
                //   0
                // )
                let transactionIndex = pickup.transactions.findIndex(
                  (txn) => txn.pickupItem.id == item.id
                );

                return (
                  <>
                    <TableRow key={item.id}>
                      <TableCell align="left">
                        <Typography sx={{ fontWeight: "bold" }}>
                          {item.itemName}
                        </Typography>
                        <Typography variant="caption">
                          {item.objectType}
                        </Typography>
                      </TableCell>
                      {!isSmallScreen && (
                        <TableCell align="left">
                          <Typography>
                            {item.quantityReceived} / {item.quantity} {item.uom}
                          </Typography>
                        </TableCell>
                      )}

                      <TableCell align="left">
                        {item.quantity - item.quantityReceived} {item.uom}
                      </TableCell>
                      <TableCell align="left">
                        <TextField
                          fullWidth
                          InputProps={{
                            inputProps: {
                              min: 0,
                              max: item.quantity - item.quantityReceived,
                            },
                          }}
                          type="number"
                          label={item.uom}
                          value={
                            pickup.transactions && transactionIndex >= 0
                              ? pickup.transactions[transactionIndex].quantity
                              : 0
                          }
                          onFocus={(event) => {
                            event.target.select();
                          }}
                          onChange={(e) => {
                            // Find index of transaction (may or may not exist)
                            let transactionsCopy = [...pickup.transactions];

                            let val = e.target.value; // val has range of 0 to max

                            // If value is zero or null/undefined, then delete transaction

                            if (!val) {
                              // IF exists, delete

                              if (transactionIndex >= 0) {
                                transactionsCopy.splice(transactionIndex, 1);
                                onUpdatePickup({
                                  transactions: transactionsCopy,
                                });
                              }
                              //   If value is within range, then update transaction (add new if doesnt exist)
                            } else if (
                              val >= 0 &&
                              val <= item.quantity - item.quantityReceived
                            ) {
                              if (transactionIndex >= 0) {
                                transactionsCopy[transactionIndex].quantity =
                                  val;
                              } else {
                                // If doesnt exist, add new
                                let newTransaction = {
                                  quantity: val,
                                  objectType: item.objectType,
                                  itemName: item.itemName,
                                  uom: item.uom,
                                  pickupItem: { id: item.id },
                                };
                                transactionsCopy.push(newTransaction);
                              }
                              onUpdatePickup({
                                transactions: transactionsCopy,
                              });
                            }
                          }}
                        />
                      </TableCell>
                      <Divider />
                    </TableRow>
                  </>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PickupForm;
